import { configureStore } from '@reduxjs/toolkit';
import LogoutReducer from './reducer/LogoutReducer';
import ChangePasswordReducer from './reducer/ChangePasswordReducer';
import LoadingReducer from './reducer/LoadingReducer';
import LoginReducer from './reducer/LoginReducer';
import ErrorTickerReducer from './reducer/ErrorTickerReducer';
import SuccessTickerReducer from './reducer/SuccessTickerReducer';
import ProductStoreReducer from './reducer/ProductStockReducer';
import ProductVarientsReducer from './reducer/ProductVarientsReducer';

export default configureStore({
  reducer: {
    loading: LoadingReducer,
    logout: LogoutReducer,
    changePassword: ChangePasswordReducer,
    login: LoginReducer,
    ErrorTicker: ErrorTickerReducer,
    SuccessTicker: SuccessTickerReducer,
    productStock: ProductStoreReducer,
    ProductVarients: ProductVarientsReducer
  },
})